require('./okDiscountExternalCodeButton.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
// @ components
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');
// @ constants
const { OKDISCOUNTS_EXTERNAL_CODE_ERRORS } = require('constants/okDiscounts');

class OkDiscountExternalCodeButton extends React.Component {

    constructor(props){
        super(props);

        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    buildCodeText() {
        const { immOkDiscount } = this.props;
        const externalCode = immOkDiscount.getIn(['externalCode', 'code'], '');
        const externalCodeError = immOkDiscount.get('externalCodeError');
        let codeText;

        if (externalCodeError) {
            let errorText;
            switch (externalCodeError) {
                case OKDISCOUNTS_EXTERNAL_CODE_ERRORS.GENERIC:
                    errorText = (
                        <span>
                            <FormattedText value="OKDiscounts-externalCodeNewError1" /><br />
                            <FormattedText value="OKDiscounts-externalCodeNewError2" />
                        </span>
                    );
                    break;
                case OKDISCOUNTS_EXTERNAL_CODE_ERRORS.CUSTOM:
                    errorText = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'code', 'text']);
                    break;
            }

            codeText = (
                <div className="okdiscount-external-code__error-message">
                    <OKMessage type="warning">
                        {errorText}
                    </OKMessage>
                </div>
            );
        } else if (externalCode) {
            codeText = (
                <div className="okdiscount-external-code__code-text">
                    <FormattedText value="OKDiscounts-externalCode" />
                    <span className="okdiscount-external-code__code">{externalCode}</span>
                </div>
            );
        }

        return codeText;
    }

    handleButtonClick(){
        this.props.requestExternalCode();
    }

    render(){
        const { immOkDiscount } = this.props;
        const externalCode = immOkDiscount.get('externalCode');
        const externalCodeFetching = immOkDiscount.get('externalCodeFetching');
        const disableButton = externalCode !== '';
        let codeText;

        if (!externalCodeFetching){
            codeText = this.buildCodeText();
        }

        return (
            <div className="okdiscount-external-code">
                <span className="okdiscount-external-code__button">
                    <OKButton
                        disabled={disableButton}
                        loading={externalCodeFetching}
                        modifier="secondary"
                        onClick={this.handleButtonClick}
                    >
                        <FormattedText value="OKDiscounts-externalCodeGet" />
                    </OKButton>
                </span>
                {codeText}
            </div>
        )
    }
}

OkDiscountExternalCodeButton.propTypes = {
    immOkDiscount: PropTypes.object.isRequired,
    requestExternalCode: PropTypes.func.isRequired
};

module.exports = OkDiscountExternalCodeButton;
